import React, { useEffect, useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import Container from '@mui/material/Container';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import LinearProgress from "@mui/material/LinearProgress";
import DialogActions from '@mui/material/DialogActions';
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import PasswordIcon from '@mui/icons-material/Password';
import axios from 'axios'


const materialTheme = createTheme(({
    // set default for now
}));

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export default function MultiFactorAuthentication(props) {

    const classes = useStyles();
    const [progressDialogText, setProgressDialogText] = useState('Sending OTP... Please wait...')
    const [showProgress, setShowProgress] = useState(false)
    const [openAlertDialog, setOpenAlertDialog] = useState(false)
    const [openAlertDialogOptVerification, setOpenAlertDialogOptVerification] = useState(false)
    const [errors, setErrors] = useState([])
    const [hasErrorInOtpVerification, setHasErrorInOtpVerification] = useState(false)
    const [hasErrorInSendingOtp, setHasErrorInSendingOtp] = useState(false)
    const [localToken, setLocalToken] = useState(null)
    const [mfaLocalToken, setMfaLocalToken] = useState(null)
    const [responseLoginToken, setResponseLoginToken] = useState(null);
    const [responseLoginMfaToken, setResponseLoginMfaToken] = useState(null);
    const [newOtp, setOtp] = useState({
        otp_verification: '',
    })
    const otpOnChange = (event) => {
        newOtp.otp_verification = event.target.value
    }
    const onFormSubmit = (event) => {
        event.preventDefault();
        otpVerification()

    }
    const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
        formData.append(key, object[key]);
        return formData;
    }, new FormData());

    useEffect(() => {
        // Check if token is already in sessionStorage
        const sessionlocalToken = sessionStorage.getItem("mfa_info_local_token");
        const sessionMfaStoredToken = sessionStorage.getItem("mfa_info_token");
        if (sessionlocalToken) {
            setLocalToken(sessionlocalToken)
        }

        if (sessionMfaStoredToken) {
            setMfaLocalToken(sessionMfaStoredToken);
        }
    }, [hasErrorInOtpVerification]);

    useEffect(() => {
        setResponseLoginToken(props.responseLoginToken);
        setResponseLoginMfaToken(props.responseLoginMfaToken)
    }, [props]);

    function otpVerification() {

        setProgressDialogText('Verifying OTP... Please wait...')
        setShowProgress(true)
        const newUserOtpCopy = { ...newOtp }
        newUserOtpCopy.token = responseLoginMfaToken

        const options = {
            credentials: false,
            method: 'POST',
            url: '/TransactiLiteMultiFactorAuthentications/validateMfa',
            data: objectToFormData(newUserOtpCopy)
        }
        axios(options)
            .then(res => {
                setShowProgress(false)

                const response = res.data;
                const error = response.errors;
                const isSucess = response.is_success;
                const message = response.message;

            
                if (isSucess) {
                    setHasErrorInOtpVerification(false)
                    localStorage.setItem("token", responseLoginToken);
                    // localStorage.setItem("token", localToken);
                    props.setIsLogin(true)
                    sessionStorage.removeItem("mfa_info_local_token");
                    sessionStorage.removeItem("mfa_info_token");
                    return;

                } else {
                    setErrors(message)
                    setHasErrorInOtpVerification(true)

                    if (message === 'OTP is Expired') {
                        props.setIsLogin(false);
                        props.setIsMultiFactorAuthentication(false);
                        return;
                    }

                    if (message === 'Entry has already expired') {
                        props.setIsLogin(false);
                        props.setIsMultiFactorAuthentication(false);
                        return;
                    }
                  
                }
                setOpenAlertDialogOptVerification(true)

            }).catch(error => {

                if (typeof error.response == 'undefined') {
                    // network error
                    setErrors([`Please checkout your internet connection.`])
                } else {
                    setErrors([`Failed to register. Code ${error.status}`])
                }
                setShowProgress(false)
                setHasErrorInOtpVerification(true)
                setOpenAlertDialogOptVerification(true)
            })
    }

    function progressDialog() {
        return (
            <>
                <Dialog fullWidth={true} maxWidth={"sm"} open={showProgress}>
                    <DialogContent>
                        <DialogContentText>{progressDialogText}</DialogContentText>

                        <Box sx={{ width: "100%" }}>
                            <LinearProgress />
                        </Box>
                    </DialogContent>
                </Dialog>
            </>
        )
    }

    function alertDialog() {
        return (
            <>
                <Dialog
                    open={openAlertDialog}
                    fullWidth={true}
                    maxWidth={'lg'}
                    onClose={() => { }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >

                    <DialogContent>

                        <Typography variant="h6" component="h2" style={{ color: (hasErrorInSendingOtp ? "red" : "green") }}>
                            {hasErrorInSendingOtp ? "Failed to send OTP. Please check error below." : "OTP sent to your email."}
                        </Typography>
                        {
                            failedMessageView()
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {

                                setOpenAlertDialog(false)
                                if (!hasErrorInSendingOtp) {
                                    // props.isResetPassword(true)
                                }

                            }}
                            color="primary" autoFocus>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        )
    }

    function failedMessageView() {
        return (
            <>
                <List>
                    <ListItem>
                        {errors}
                    </ListItem>
                </List>
            </>
        )
    }

    function alertOtpVerificationDialog() {
        return (
            <>
                <Dialog
                    open={openAlertDialogOptVerification}
                    fullWidth={true}
                    maxWidth={'lg'}
                    onClose={() => { }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >

                    <DialogContent>

                        <Typography variant="h6" component="h2" style={{ color: (hasErrorInOtpVerification ? "red" : "green") }}>
                            {hasErrorInOtpVerification ? "Wrong OTP. Please check error below." : "OTP Verified Successfully."}
                        </Typography>
                        {
                            hasErrorInOtpVerification ? failedMessageOtpVerificationView() : ""
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {

                                setOpenAlertDialogOptVerification(false)
                                if (!hasErrorInOtpVerification) {
                                    // props.isResetPassword(true)
                                }

                            }}
                            color="primary" autoFocus>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        )
    }

    function failedMessageOtpVerificationView() {
        return (
            <>
                <List>
                    <ListItem>
                        {errors}
                    </ListItem>
                </List>
            </>
        )
    }

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <PasswordIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    OTP
                </Typography>

                <Typography>
                    {' Multi-Factor Authentication (MFA)'}
                </Typography>
                <form className={classes.form} autoComplete="off" onSubmit={onFormSubmit}>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={materialTheme}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        variant="outlined"
                                        required
                                        fullWidth
                                        id="otp_verification"
                                        label="OTP Verification"
                                        name="otp_verification"
                                        onChange={otpOnChange}
                                    />
                                </Grid>
                            </Grid>
                        </ThemeProvider>
                    </StyledEngineProvider>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        {'Submit OTP'}
                    </Button>
                </form>
            </div>
            <Box mt={5}>
                {/* <Copyright /> */}
            </Box>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                    {progressDialog()}
                    {alertDialog()}
                    {alertOtpVerificationDialog()}
                </ThemeProvider>
            </StyledEngineProvider>
        </Container>
    );
}